<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <div class="q-card gvn-cabecalho ">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <strong>Requerente: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.nomRequerente}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Logradouro: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.logradouro.nomLogradouro}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Número: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.numNumero}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Nº do Processo | Ano: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.numProcesso}} | {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.anoProcesso}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Tipo de Processo: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.tipoProcesso.desTipoProcesso}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Bairro: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.bairro.nomBairro}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Cidade: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.municipio.nomMunicipio}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Nº Protocolo: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.numProtocolo}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Assunto: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.subassunto.assunto.desAssunto}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>E-mail: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.txtEmail || this.paginaStatus.usuarioPortal.txtEmail}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>UF: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.uf.nomUf}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Rota: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.roteiro.numRota}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Subassunto: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.subassunto.desSubassunto}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Telefone móvel: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.numTelefoneMovel || this.paginaStatus.usuarioPortal.numTelefoneMovel}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Telefone Comercial: </strong>
          {{this.paginaStatus.movimentacaoProcesso.aberturaProcesso.requerente.numTelefoneComercial || this.paginaStatus.usuarioPortal.numTelefoneComercial}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Data | Hora: </strong>
          {{this.datProcesso}}
        </div>
      </div>
      <br />
      <br />
      <div v-if="arrayDocumentosNecessarios.length > 0" class='row' style="margin-right: 8px; margin-left: 8px;">
        <table
          class="col-md-12"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th
                class="text-left"
                width="50%"
              >
                Documentação Obrigatória
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="doc in arrayDocumentosNecessarios"
              v-bind:key="doc.a"
            >
              <td class="text-left">
                {{doc.documento.nomDocumento}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <form
      @submit.prevent="salvar"
      style="margin-top:25px;"
      enctype="multipart/form-data"
    >
      <g-gridview
        id="refDocumentos"
        name="refDocumentos"
        ref="refDocumentos"
        :exibirEtiqueta="false"
        :colunas="colunasGrid"
        :inserirElemento="getElemento"
        :getElemento="getElemento"
        :editarElemento="editarElemento"
        :executarValidacao="validarDocumento"
        :limparCampos="limparDocumento"
        :exibirBotaoExclusao="exclusao"
        :desabilitar="paginaStatus.desabilitarEdicao"
        :confExcluir="confExcluirDocumento"
        :inicializarVazio="true"
        :exibirBotaoVisualizacao="false"
        :exibirBotaoEdicao="false"
        :operacoes="operacoes"
      >
        <div class="row">
          <div class="col-12 gvn-title-primary mrg-t-0">Dados da Anexação</div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <g-autocomplete
              id="refResponsavel"
              name="refResponsavel"
              ref="refResponsavel"
              validacao="required"
              etiqueta="Responsável"
              valor="usuario.codUsuario"
              descricaoPrimaria="usuario.nomUsuario"
              :api=apiResponsavelSetor
              :foco="false"
              :filtroAdicional="filtroAdicionalResponsavel"
              :desabilitar="true"
              v-model="codUsuario"
            >
            </g-autocomplete>
          </div>
          <div
            class="col-sm-4 col-xs-4"
            style="padding-right: 10px;"
          >
            <g-dateInput
              id="refDataAnexacao"
              name="refDataAnexacao"
              ref="refDataAnexacao"
              etiqueta="Data de Anexação"
              validacao="required"
              v-model="datAnexacao"
              :desabilitar="false"
              :somenteLeitura="paginaStatus.desabilitarEdicao"
              :dataMax="new Date()"
            >
            </g-dateInput>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-6 col-xs-6"
            style="padding-top: 9px; "
          >
            <g-autocomplete
              id="refDocumento"
              name="refDocumento"
              ref="refDocumento"
              etiqueta="Documento"
              valor="codDocumento"
              descricaoPrimaria="nomDocumento"
              validacao="required"
              :api=apiDocumento
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="codDocumento"
              permitirTextoLivre
            >
            </g-autocomplete>
          </div>
          <div
            class="col-sm-6 col-xs-6"
            style="padding-top: 9px; "
          >
            <!-- <input
            ref="refArquivo"
            type="file"
            name="arquivo"
          /> -->
            <q-uploader
              color="secondary"
              ref="refUploader"
              name="arquivo"
              type="file"
              auto-expand
              hide-upload-button
              hide-upload-progress
              validacao="required"
              stack-label="Selecionar arquivo (Tamanho máximo: 25Mb)"
              :url="urlArquivo"
              :filter="filtroDeArquivos"
            />
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-12 col-xs-12"
            style="padding-top: 9px"
          >
            <g-input
              id="refObservacao"
              name="refObservacao"
              ref="refObservacao"
              tipo="textarea"
              etiqueta="Observação"
              :tamanho=1000
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="txtObservacao"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-11 col-xs-11">
            <g-select
              id="refDisponibilidade"
              name="disponibilidade"
              ref="disponibilidade"
              etiqueta="Arquivo ficará disponível"
              :foco="false"
              :itens="arrayDisponibilidadeArray"
              item-valor="codigo"
              item-etiqueta="descricao"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="disponibilidade"
            >
            </g-select>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
            <q-btn round outline icon="fas fa-info" size="sm" color="blue-10" style="margin-top:15px;">
              <q-tooltip style="font-size: 13px;" anchor="top middle" self="bottom middle" :offset="[10, 10]">
                <strong>Internamente:</strong> Ficará disponível internamente no processo. <br /><br />
                <strong>Externamente:</strong> Ficará disponível para o requisitante no <strong>Portal Web.</strong> <br /><br />
                <strong>Externamente (Apenas no encerramento do processo): </strong>
                Ficará disponível para o requisitante no <strong>Portal Web </strong>
                se o status do processo for <strong> Encerrado </strong>
              </q-tooltip>
            </q-btn>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mrg-t-10" v-if="disponibilidade === 'EXT'">
            <q-toggle
              id="toogleSetorAtivo"
              name="toogleSetorAtivo"
              v-model="indGerarNovaPendencia"
              label="Gerar uma nova pendência"
              color="teal-8"
              :disable="paginaStatus.desabilitarEdicao"
              true-value="S"
              false-value="N"
              checked-icon="check"
              unchecked-icon="clear"
            />
          </div>
        </div>
      </g-gridview>
    </form>

    <q-card v-if="exibirArquivosSolicitacao">
      <q-card-main>
        <div class="row">
          <div class="col-12 gvn-title-primary mrg-t-0">Arquivos anexados na solicitação</div>
        </div>
        <div class="row mrg-b-20">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <g-datatable
              id="refSolicitacaoMovimentacaoDocumentos"
              name="refSolicitacaoMovimentacaoDocumentos"
              ref="refSolicitacaoMovimentacaoDocumentos"
              :colunas="colunasSolicitacaoDocumentos"
              :operacoes="operacoesSolicitacaoDocumentos"
              :exibirColunaOperacoes="true"
              :carregamentoInicial="false"
            >
            </g-datatable>
          </div>
        </div>
      </q-card-main>
    </q-card>

    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="btnSalvar"
        name="btnSalvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
// IMPORTS
import api from 'components/util/api'
import util from 'components/util/util'
import GInput from 'components/util/gInput'
import GGridview from 'components/util/gGridview'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GAutocomplete from 'components/util/gAutocomplete'
import GSelect from 'components/util/gSelect'
import GDatepicker from 'components/util/gDatepicker'
import utilHttp from 'components/util/utilHttp'
import msg from 'components/util/msg'
import GDateInput from 'components/util/gDateInput'
import GDatatable from 'components/util/gDatatable'

export default {
  data () {
    return {
      chaveLocalStorage: 'encerramentoMovimentacaoProcesso',
      apiResponsavelSetor: api.RESPONSAVEL_SETOR,
      apiDocumento: api.DOCUMENTO,
      apiDocumentoAnexoProcesso: api.DOCUMENTO_ANEXO_PROCESSO,
      apiDownloadArquivo: api.DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVO,
      apiDownloadArquivos: api.DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVOS,
      apiEmail: api.DOCUMENTO_ANEXO_PROCESSO_ENVIAR_EMAIL_ARQUIVO_EXTERNO,
      documentoUpload: '',
      codUsuario: '',
      datAnexacao: '',
      codDocumento: '',
      txtObservacao: '',
      exclusao: '',
      datProcesso: '',
      dataAnexo: '',
      urlArquivo: '',
      arquivo: '',
      indGerarNovaPendencia: 'N',
      exibirArquivosSolicitacao: false,
      documentoSelecionado: {
        documento: ''
      },
      documentoAnexoProcessoExcluirList: [],
      arrayDocumentosNecessarios: [],
      arrayDocumentoAnexoProcessoBkp: [],
      arrayDisponibilidadeArray: [
        { codigo: 'INT', descricao: 'Internamente' },
        { codigo: 'EXT', descricao: 'Externamente' },
        { codigo: 'ENC', descricao: 'Externamente (Apenas no encerramento do processo)' }
      ],
      disponibilidade: 'INT',
      paginaStatus: {
        desabilitarEdicao: false,
        documentoAnexoProcesso: {
          aberturaProcesso: {
            codProcesso: '',
            tipoProcesso: {},
            subassunto: { assunto: {} },
            roteiro: {},
            requerente: {}
          },
          responsavelSetor: {},
          documento: {},
          arquivo: {}
        }
      },
      confExcluirDocumento: {
        clique: (item) => this.confExcluirDocumentoFuncao(item)
      },
      caminhoMigalha: [
        {
          icone: '',
          descricao: '',
          rotaNome: ''
        }
      ],
      colunasGrid: [
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoEtiqueta: 'Documentos Anexados',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'documento.nomDocumento',
          chave: 'documento.nomDocumento'
        },
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoEtiqueta: 'Observação',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'txtObservacao'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoEtiqueta: 'Disponível',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'indDisponibilidade',
          formatar: (valor) => this.formatarDisponibilidade(valor)
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoEtiqueta: 'Tamanho aproximado do arquivo',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'tamanhoArquivo',
          formatar: (valor) => this.formatarTamanhoArquivo(valor)
        }
      ],
      operacoes: [
        {
          cor: 'black',
          icone: 'fas fa-download',
          tooltip: 'Baixar Arquivo',
          clique: this.baixarAnexo,
          permissao: (row) => true,
          visivel: (row) => this.habilitarBaixarAnexo(row)
        }
      ],
      colunasSolicitacaoDocumentos: [
        {
          conteudoTipo: '',
          largura: '60%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Documentos Anexados',
          conteudoClasse: 'text-left',
          propriedade: 'documento.nomDocumento'
        }
      ],
      operacoesSolicitacaoDocumentos: [
        {
          cor: 'black',
          icone: 'fas fa-download',
          tooltip: 'Baixar Arquivo',
          clique: this.baixarAnexo,
          permissao: (row) => true,
          visivel: (row) => true
        }
      ]
    }
  },
  methods: {
    formatarTamanhoArquivo (tamanho) {
      return (tamanho / 1024 / 1024).toFixed(4) + ' Mb'
    },
    formatarDisponibilidade (indDisponibilidade) {
      if (indDisponibilidade === 'INT') {
        return 'Internamente'
      } else if (indDisponibilidade === 'EXT') {
        return 'Externamente'
      } else {
        return 'Externamente (Apenas no encerramento do processo)'
      }
    },
    filtroDeArquivos (files) {
      const MAX_FILE_SIZE = 25 * 1024 * 1024 /* =25M */
      // returns an Array containing allowed files
      return files.filter((file) => {
        if (file.size > MAX_FILE_SIZE) {
          util.exibirToastAviso('Arquivo [' + files[0].name + '] excede o tamanho permitido: 25 Mb')
        }
        return file.size <= MAX_FILE_SIZE
      })
    },
    async forceFileDownload (response, item) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      utilHttp.httpGet(this.apiDownloadArquivo.concat('/getNomeArquivo/').concat(item.codUpload), (resposta) => {
        link.setAttribute('download', resposta.bodyText)
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadWithVueResource (item) {
      this.$http({
        method: 'get',
        url: this.apiDownloadArquivo.concat('/').concat(item.codUpload),
        responseType: 'arraybuffer',
        headers: utilHttp.getCabecalhoAutorizacao().headers
      })
        .then(response => {
          this.forceFileDownload(response, item)
        })
        .catch(() => console.error('Erro ao baixar arquivo'))
    },
    baixarAnexo (item) {
      var self = this
      let url = self.apiDownloadArquivos.concat('/')
      if (util.validarCampo(item.codUpload)) {
        url += item.codUpload
      } else {
        if (util.validarCampo(item.servidorArquivo)) {
          if (util.validarCampo(item.servidorArquivo.codArquivo)) {
            url += item.servidorArquivo.codArquivo
          } else {
            util.exibirToastAviso('Arquivo não encontrado')
            return
          }
        } else {
          util.exibirToastAviso('Arquivo não encontrado')
          return
        }
      }
      utilHttp.httpGet(url, resposta => {
        location.href = url
      })
    },
    habilitarBaixarAnexo (item) {
      if (item.codUpload !== null && item.codUpload !== undefined && item.codUpload !== '') {
        return true
      } else {
        return false
      }
    },
    editarElemento (item) {
      var self = this
      // correcao do icone de editar sumir quando carrega outro grid
      if (this.paginaStatus.operacao.descricao === 'Visualizar') {
        self.$refs['refDocumentos'].indexEdicao = ''
      }
      self.documentoSelecionado = item
      self.$refs['refResponsavel'].carregar(self.documentoSelecionado.responsavelSetor.usuario.codUsuario, self.documentoSelecionado.responsavelSetor.usuario.nomUsuario)
      self.datAnexacao = self.documentoSelecionado.datAnexacao
      self.$refs['refDocumento'].carregar(self.documentoSelecionado.documento.codDocumento, self.documentoSelecionado.documento.nomDocumento)
      self.txtObservacao = self.documentoSelecionado.txtObservacao
      self.indDisponibilidade = item.indDisponibilidade
    },
    buscarResponsavel () {
      var self = this
      var responsavelSetor = {}
      var filtro = ''
      if (util.validarCampo(self.paginaStatus.movimentacaoProcesso.setorConfirmacao.codSetor)) {
        filtro = ''
          .concat('?codUsuario=')
          .concat(self.$login.getCodUsuario())
          .concat('&codSetor=')
          .concat(self.paginaStatus.movimentacaoProcesso.setorConfirmacao.codSetor)
          .concat('&codUnidade=')
          .concat(self.paginaStatus.movimentacaoProcesso.setorConfirmacao.unidade.codUnidade)
          .concat('&codOrgao=')
          .concat(self.paginaStatus.movimentacaoProcesso.setorConfirmacao.unidade.orgao.codOrgao)
          .concat('&indModulo=')
          .concat('PRO')
      } else {
        filtro = ''
          .concat('?codUsuario=')
          .concat(self.$login.getCodUsuario())
          .concat('&codSetor=')
          .concat(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.codSetor)
          .concat('&codUnidade=')
          .concat(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.codUnidade)
          .concat('&codOrgao=')
          .concat(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao)
          .concat('&indModulo=')
          .concat('PRO')
      }
      utilHttp.httpGet(api.RESPONSAVEL_SETOR_USUARIO_SETOR_UNIDADE_ORGAO.concat(filtro), resposta => {
        responsavelSetor = resposta.body
        if (responsavelSetor) {
          self.paginaStatus.documentoAnexoProcesso.responsavelSetor = responsavelSetor
          setTimeout(() => {
            if (self.paginaStatus.documentoAnexoProcesso.responsavelSetor.codResponsavel) {
              self.codUsuario = self.paginaStatus.documentoAnexoProcesso.responsavelSetor.usuario.codUsuario
              self.$refs['refResponsavel'].carregar(
                self.paginaStatus.documentoAnexoProcesso.responsavelSetor.usuario.codUsuario,
                self.paginaStatus.documentoAnexoProcesso.responsavelSetor.usuario.nomUsuario
              )
              self.$refs['refResponsavel'].objetoSelecionado = self.paginaStatus.documentoAnexoProcesso.responsavelSetor
            }
          }, 200)
        }
      })
    },
    filtroAdicionalResponsavel () {
      var filtro = ''
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.codSetor)
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.codUnidade)
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao)
      return filtro
    },
    carregaGrid () {
      // carrega o grid de acordo com o codProcesso
      var self = this
      self.paginaStatus.documentoAnexoProcesso.codUsuario = self.$login.getCodUsuario()
      if (self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.codProcesso) {
        var filtro = ''
          .concat('/').concat(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.codProcesso)
        utilHttp.httpGetCarregando(api.BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO.concat(filtro), resposta => {
          if (resposta.body.length > 0) {
            var listaDocumentosAnexoProcesso = resposta.body.filter(x => x.indAnexadoAbertura !== 'S')
            self.arrayDocumentoAnexoProcessoBkp = JSON.parse(JSON.stringify(listaDocumentosAnexoProcesso))
            this.$refs['refDocumentos'].inicializar(listaDocumentosAnexoProcesso)
          }
        })
      }
    },
    buscarDocumentoNecessario () {
      // RN010-Documentos obrigatórios a grid deverá vir preenchida com os documentos necessários
      // para o processo informado.
      var filtro = ''
        .concat('?codTipoProcesso=').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.tipoProcesso.codTipoProcesso)
        .concat('&codAssunto=').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.subassunto.assunto.codAssunto)
        .concat('&codSubassunto=').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.subassunto.codSubassunto)
      utilHttp.httpGet(api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(filtro), resposta => {
        this.arrayDocumentosNecessarios = resposta.body
      })
    },
    confExcluirDocumentoFuncao (item) {
      var self = this
      util.exibirConfirmacaoExclusao('EXCLUSÃO', msg.m(5), () => {
        this.$refs['refDocumentos'].removerElementoAposConfirmacaoExclusao(item)
        // adiciona na lista de excluir
        self.documentoAnexoProcessoExcluirList.push(item)
      })
    },
    limparDocumento () {
      this.$refs['refUploader'].reset()
      this.$refs['refDocumento'].limpar()
      this.txtObservacao = ''
    },
    validarDocumento () {
      var self = this
      self.tratarData()
      if (self.datAnexacao) {
        if (self.dataAnexo < this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.datProcesso) {
          util.exibirToastAviso('Favor verificar a data informada')
          return false
        }
      }
      if (!util.validarCampo(self.codDocumento)) {
        util.exibirToastAviso('Documento não foi informado')
        return false
      }
      if (!self.$refs['refUploader'].files[0]) {
        util.exibirToastAviso('Arquivo não foi informado')
        return false
      }
      let lista = self.$refs['refDocumentos'].getDados()
      if (lista.length > 0) {
        let initialValue = 0
        lista.forEach(item => {
          let tamanhoAtualizado = 0
          if (!util.validarCampo(item.tamanhoArquivo)) {
            tamanhoAtualizado = parseFloat(item.documento.arquivo.size) / 1024 / 1024
          } else {
            tamanhoAtualizado = parseFloat(item.tamanhoArquivo) / 1024 / 1024
          }
          initialValue = initialValue + parseFloat(tamanhoAtualizado)
        })
        if ((parseFloat(initialValue.toFixed(4)) + parseFloat((self.documentoSelecionado.documento.arquivo.size / 1024 / 1024).toFixed(4))) > 25.000) {
          util.exibirToastAviso('Não foi possível incluir o arquivo [' + self.documentoSelecionado.documento.arquivo.name + '], o limite total de 25Mb foi ultrapassado!')
          return false
        }
      }
      if (self.datAnexacao &&
        self.codDocumento &&
        self.disponibilidade &&
        self.txtObservacao &&
        self.$refs['refUploader'].files[0]) {
        return true
      } else {
        if (self.datAnexacao === null || self.datAnexacao === '') {
          util.exibirToastAviso(msg.m(11, 'Data de Anexação'))
        } else if (self.codDocumento === '') {
          util.exibirToastAviso(msg.m(11, 'Documento'))
        } else if (self.$refs['refUploader'].files[0] === undefined) {
          util.exibirToastAviso(msg.m(11, 'Arquivo'))
        } else if (self.disponibilidade === '') {
          util.exibirToastAviso(msg.m(11, 'Disponibilidade do arquivo'))
        } else if (self.txtObservacao === '') {
          util.exibirToastAviso(msg.m(11, 'Observação'))
        }
        return false
      }
    },
    getElemento () {
      var self = this
      self.tratarData()
      if (self.datAnexacao && self.codDocumento && self.$refs['refUploader'].files[0]) {
        self.documentoSelecionado = JSON.parse(JSON.stringify(self.documentoSelecionado))
        if (self.$refs['refDocumento'].objetoSelecionado.codDocumento) {
          self.documentoSelecionado.documento = self.$refs['refDocumento'].objetoSelecionado
        }
        if (self.$refs['refResponsavel'].objetoSelecionado.codResponsavel) {
          self.documentoSelecionado.responsavel = self.$refs['refResponsavel'].objetoSelecionado
        }

        if (self.$refs['refUploader'] !== undefined && self.$refs['refUploader'] !== '' && self.$refs['refUploader'] !== null) {
          self.documentoSelecionado.documento.arquivo = self.$refs['refUploader'].files[0]
        }
        self.documentoSelecionado.datAnexacao = util.criarData(self.datAnexacao)
        self.documentoSelecionado.txtObservacao = self.txtObservacao
        self.documentoSelecionado.codUsuario = self.$login.getCodUsuario()
        self.documentoSelecionado.aberturaProcesso = self.paginaStatus.documentoAnexoProcesso.aberturaProcesso
        self.documentoSelecionado.indDisponibilidade = self.exibirArquivosSolicitacao ? self.disponibilidade : 'INT'
        if (self.documentoSelecionado.indDisponibilidade === 'EXT' && self.indGerarNovaPendencia === 'S') {
          self.documentoSelecionado.indGerarNovaPendencia = 'S'
        } else {
          self.documentoSelecionado.indGerarNovaPendencia = 'N'
        }
        self.documentoSelecionado.tamanhoArquivo = parseFloat(self.documentoSelecionado.documento.arquivo.size)
        if (self.codDocumento === '') self.documentoSelecionado.documento = {}

        // Verificar se o elemento selecionado existe na lista de exclusão, se existir, o retira
        var doc = self.documentoAnexoProcessoExcluirList.filter(d => d.documento.codDocumento === self.documentoSelecionado.documento.codDocumento)
        if (doc !== undefined && doc != null && doc.length > 0) {
          self.documentoAnexoProcessoExcluirList.splice(doc, 1)
        }
      }
      return self.documentoSelecionado
    },
    salvar () {
      var self = this
      iniciar()
      async function iniciar () {
        self.paginaStatus.documentoAnexoProcesso.datAnexacao = self.datAnexacao
        var documentoAnexoProcessoSalvarList = self.$refs['refDocumentos'].getDadosEditados(self.arrayDocumentoAnexoProcessoBkp, 'documento.nomDocumento')
        if (documentoAnexoProcessoSalvarList.length === 0 && self.documentoAnexoProcessoExcluirList.length === 0) {
          util.exibirToastSucesso(msg.m(21))
        } else {
          self.paginaStatus.documentoAnexoProcesso.datAnexacao = new Date(util.formatarAnoMesDia(self.paginaStatus.documentoAnexoProcesso.datAnexacao, 'DD/MM/YYYY'))
          util.mostrarCarregando()
          let arrayPendencias = []
          let responsavelSetor = {}
          if (documentoAnexoProcessoSalvarList.filter(x => x.indGerarNovaPendencia === 'S').length > 0) {
            arrayPendencias = await buscarPendenciasProcesso(self.paginaStatus.movimentacaoProcesso.aberturaProcesso)
            responsavelSetor = await buscarResponsavelSetor(self.paginaStatus.movimentacaoProcesso.setorConfirmacao)
          }
          if (await salvarList(documentoAnexoProcessoSalvarList, responsavelSetor, arrayPendencias) && await excluirList(self.documentoAnexoProcessoExcluirList)) {
            util.esconderCarregando()
            util.exibirToastSucesso(msg.m(3))
            util.retornarCaminhoMigalhaPaginaAnterior(self)
          } else {
            util.esconderCarregando()
          }
        }
      }
      function buscarResponsavelSetor (setorConfirmacao) {
        return new Promise(resolve => {
          var filtro = ''
            .concat('?codUsuario=')
            .concat(self.$login.getCodUsuario())
            .concat('&codSetor=')
            .concat(setorConfirmacao.codSetor)
            .concat('&codUnidade=')
            .concat(setorConfirmacao.unidade.codUnidade)
            .concat('&codOrgao=')
            .concat(setorConfirmacao.unidade.orgao.codOrgao)
            .concat('&indModulo=')
            .concat('PRO')
          utilHttp.httpGet(api.RESPONSAVEL_SETOR_USUARIO_SETOR_UNIDADE_ORGAO.concat(filtro), resposta => {
            return resolve(resposta.body)
          })
        })
      }
      function buscarPendenciasProcesso (aberturaProcesso) {
        return new Promise(resolve => {
          if (aberturaProcesso.numProcesso) {
            var filtro = ''
              .concat('?numProcesso=').concat(aberturaProcesso.numProcesso)
              .concat('&anoProcesso=').concat(aberturaProcesso.anoProcesso)
            utilHttp.httpGet(api.PENDENCIA_PROCESSO_PROCESSO.concat(filtro), resposta => {
              var listaPendenciaProcesso = resposta.body
              listaPendenciaProcesso.forEach(item => {
                item.desSetorPendencia = item.indLocalPendencia === 'INT' ? item.movimentacaoProcesso.setorConfirmacao.desSetor : item.movimentacaoProcesso.aberturaProcesso.requerente.nomRequerente
              })
              return resolve(listaPendenciaProcesso)
            })
          } else {
            return resolve([])
          }
        })
      }
      function salvarList (documentoAnexoProcessoSalvarList, responsavelSetor, arrayPendencias) {
        return new Promise(resolve => {
          if (documentoAnexoProcessoSalvarList.length > 0) {
            var count = 0
            arrayPendencias.forEach(pendencia => {
              if (count < pendencia.numSequencia) {
                count = pendencia.numSequencia
              }
            })
            documentoAnexoProcessoSalvarList.forEach(item => {
              item.aberturaProcesso = self.paginaStatus.documentoAnexoProcesso.aberturaProcesso
              item.responsavelSetor = self.$refs['refResponsavel'].objetoSelecionado
            })
            // Necessário salvar item por item da lista por conta do arquivo de upload
            var enviouEmail = false
            documentoAnexoProcessoSalvarList.forEach(d => {
              const formData = new FormData()
              formData.append('arquivo', d.documento.arquivo)
              formData.append('codResponsavel', d.responsavelSetor.codResponsavel)
              formData.append('codDocumento', d.documento.codDocumento)
              formData.append('observacao', d.txtObservacao)
              formData.append('codProcesso', self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.codProcesso)
              formData.append('codUsuario', d.codUsuario)
              formData.append('indDisponibilidade', d.indDisponibilidade)
              formData.append('datAnexacao', util.dataHoraParaString(self.paginaStatus.documentoAnexoProcesso.datAnexacao))
              formData.append('indAnexadoAbertura', d.indAnexadoAbertura === 'S' ? '' : 'N')
              formData.append('nomDocumento', '')
              utilHttp.httpPostMultpartRequest(self.apiDocumentoAnexoProcesso, formData, resposta => {
                var pendenciaProcessoVisao = {
                  pendenciaProcessoSalvarList: [],
                  pendenciaProcessoExcluirList: []
                }
                if (d.indGerarNovaPendencia === 'S') {
                  let pendencia = {
                    movimentacaoProcesso: {}
                  }
                  pendencia.movimentacaoProcesso = self.paginaStatus.movimentacaoProcesso
                  pendencia.indLocalPendencia = 'EXT'
                  pendencia.txtPendencia = d.txtObservacao
                  pendencia.datPendencia = util.criarData(self.paginaStatus.documentoAnexoProcesso.datAnexacao)
                  pendencia.codUsuario = self.$login.getCodUsuario()
                  pendencia.indStatusPendencia = 'Aberta'
                  pendencia.codPendencia = null
                  pendencia.responsavelSetor = responsavelSetor
                  pendencia.numSequencia = count + 1
                  pendenciaProcessoVisao.pendenciaProcessoSalvarList.push(pendencia)
                  utilHttp.httpPost(api.PENDENCIA_PROCESSO, pendenciaProcessoVisao, resposta => {
                  })
                }
                if (d.indDisponibilidade === 'EXT' && !util.validarCampo(d.codUpload) && !enviouEmail) {
                  utilHttp.httpGet(`${self.apiEmail}?codProcesso=${self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.codProcesso}`, respostaEmail => {
                    enviouEmail = true
                  })
                }
              })
            })
          }
          setTimeout(() => {
            return resolve(true)
          }, 1000)
        })
      }
      function excluirList (documentoAnexoProcessoExcluirList) {
        return new Promise(resolve => {
          if (documentoAnexoProcessoExcluirList.length > 0) {
            documentoAnexoProcessoExcluirList.forEach(d => {
              if (d.codAnexo !== null && d.codAnexo !== undefined && d.codAnexo !== '') {
                utilHttp.httpDeletePorID(self.apiDocumentoAnexoProcesso.concat('/').concat(d.codAnexo), resposta => {
                })
              }
            })
          }
          setTimeout(() => {
            return resolve(true)
          }, 1000)
        })
      }
    },
    colocarDataProcesso () {
      var self = this
      let dp = new Date(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.datProcesso)
      let dia = String(dp.getDate()).padStart(2, '0')
      let mes = String(dp.getMonth() + 1).padStart(2, '0')
      let ano = String(dp.getFullYear())

      var dHoraProcesso = dia + '/' + mes + '/' + ano + ' | ' + self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.horProcesso

      self.datProcesso = dHoraProcesso
    },
    setDataAtual () {
      var self = this
      let dataAtual = new Date()

      self.datAnexacao = util.formatarData(dataAtual, 'dd/mm/yyyy')
    },
    tratarData () {
      var self = this

      if (self.datAnexacao !== null && self.datAnexacao !== undefined && self.datAnexacao !== '') {
        let da = new Date(util.formatarAnoMesDia(self.datAnexacao, 'DD/MM/YYYY'))
        let dia = String(da.getDate()).padStart(2, '0')
        let mes = String(da.getMonth() + 1).padStart(2, '0')
        let ano = String(da.getFullYear())

        var dAnexo = ano + '-' + mes + '-' + dia

        self.dataAnexo = dAnexo.concat('T23:59:59.000-00:00')
      }
    },
    carregarGridDocumentos () {
      var self = this
      var protocoloSolicitacaoMovimentacaoLista = []
      iniciar()
      async function iniciar () {
        self.exibirArquivosSolicitacao = true
        let arrayAnexadoPortal = await self.buscarDocumentosAnexadosPortal(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.idProtocoloSolicitacao)
        let arrayAnexadoAbertura = await self.buscarDocumentosAnexadosAbertura(self.paginaStatus.documentoAnexoProcesso.aberturaProcesso.codProcesso)
        iniciarGrid(arrayAnexadoPortal, arrayAnexadoAbertura)
      }
      function iniciarGrid (arrayAnexadoPortal, arrayAnexadoAbertura) {
        if (arrayAnexadoPortal.length > 0 || arrayAnexadoAbertura.length > 0) {
          arrayAnexadoAbertura.forEach(item => {
            if (protocoloSolicitacaoMovimentacaoLista.filter(x => x.nomDocumento === item.nomDocumento).length === 0) {
              let documentoSelecionado = item
              documentoSelecionado.documento = {
                nomDocumento: item.nomDocumento,
                arquivo: null
              }
              documentoSelecionado.tamanhoArquivo = item.tamanhoArquivo
              documentoSelecionado.indDisponibilidade = 'INT'
              protocoloSolicitacaoMovimentacaoLista.push(documentoSelecionado)
            }
          })
          arrayAnexadoPortal.forEach(item => {
            if (protocoloSolicitacaoMovimentacaoLista.filter(x => x.documento.nomDocumento === item.servidorArquivo.nomeArquivo).length === 0) {
              let documentoSelecionado = item
              documentoSelecionado.documento = {
                nomDocumento: item.servidorArquivo.nomeArquivo,
                arquivo: null
              }
              documentoSelecionado.tamanhoArquivo = item.servidorArquivo.tamanho
              documentoSelecionado.indDisponibilidade = 'INT'
              protocoloSolicitacaoMovimentacaoLista.push(documentoSelecionado)
            }
          })
          setTimeout(() => {
            self.$refs['refSolicitacaoMovimentacaoDocumentos'].inicializar(protocoloSolicitacaoMovimentacaoLista)
          }, 250)
        }
      }
    },
    async buscarDocumentosAnexadosPortal (idProtocoloSolicitacao) {
      return new Promise(resolve => {
        if (idProtocoloSolicitacao) {
          let filtro = '?id='.concat(idProtocoloSolicitacao)
          utilHttp.httpGetCarregando(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOCUMENTOS.concat(filtro), resposta => {
            return resolve(resposta.body.filter(x => x.indAnexadoAbertura !== 'S'))
          })
        } else {
          return resolve([])
        }
      })
    },
    async buscarDocumentosAnexadosAbertura (codProcesso) {
      return new Promise(resolve => {
        if (codProcesso) {
          var filtro = '/'.concat(codProcesso)
          utilHttp.httpGet(api.BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO.concat(filtro), resposta => {
            return resolve(resposta.body.filter(x => x.indAnexadoAbertura === 'S'))
          })
        } else {
          return resolve([])
        }
      })
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    codUsuario: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.documentoAnexoProcesso.responsavelSetor = this.$refs['refResponsavel'].objetoSelecionado
        }
      }
    },
    disponibilidade: {
      handler (valor) {
        if (valor !== 'EXT') {
          this.indGerarNovaPendencia = 'N'
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      var self = this
      if (self.$route.params.paginaStatus) {
        self.paginaStatus = self.$route.params.paginaStatus
        self.paginaStatus.caminhoMigalha.push({
          icone: this.paginaStatus.operacao.icone,
          descricao: this.paginaStatus.operacao.descricao,
          rotaNome: 'documentoAnexoProcesso'
        })
      } else if (util.recuperarDoStorage(self.chaveLocalStorage)) {
        self.paginaStatus = util.recuperarDoStorage(self.chaveLocalStorage)
      }
      self.carregaGrid()
      self.buscarDocumentoNecessario()
      self.carregarGridDocumentos()

      if (!self.paginaStatus.documentoAnexoProcesso.responsavelSetor) {
        self.paginaStatus.documentoAnexoProcesso.responsavelSetor = {}
      }

      self.buscarResponsavel()
      setTimeout(() => {
        self.colocarDataProcesso()
      }, 200)
      this.setDataAtual()
    })
  },
  components: { GBreadcrumb, GAutocomplete, GInput, GGridview, GSelect, GDatepicker, GDateInput, GDatatable }
}

</script>
